import React from 'react';
import CustomTooltip from './CustomTooltip';
import { VariantType } from './types';

interface Props {
  text: string;
  position: {
    top: string;
    left: string;
  };
  variant?: VariantType;
  containerRef?: React.RefObject<HTMLElement>;
}

export const Tooltip: React.FC<Props> = ({
  text,
  position,
  variant = 'teal',
  containerRef,
}) => {
  return (
    <CustomTooltip
      text={text}
      absolutePosition={position}
      isTagStyle={true}
      arrow={false}
      variant={variant}
      isOpen={true}
      containerRef={containerRef}
    />
  );
}; 